{
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "submit": "Submit",
    "search": "Search",
    "loading": "Loading...",
    "yes": "Yes",
    "no": "No",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "confirm": "Confirm",
    "done": "Done",
    "remove": "Remove",
    "add": "Add",
    "view": "View",
    "create": "Create",
    "update": "Update",
    "ok": "OK",
    "none": "None",
    "na": "N/A",
    "prepare": "Prepare",
    "approve": "Approve",
    "uploadFiles": "Upload Files",
    "learnMore": "Learn more",
    "user": "user",
    "users": "users"
  },
  "nav": {
    "users": "Users",
    "groups": "Groups",
    "developerApiTokens": "Developer API tokens",
    "permissions": "Permissions",
    "betaFeatures": "Beta features",
    "security": "Security",
    "adminSettings": "Admin settings"
  },
  "pages": {
    "unauthorized": {
      "title": "Unauthorized",
      "heading": "We're sorry!",
      "message": "It seems you don't have access to this page.",
      "contactSupport": "If you think this is an error, please reach out to Customer Success."
    },
    "errorBoundary": {
      "message": "Something has gone wrong!"
    },
    "passwords": {
      "title": "Passwords Page",
      "description": "When this option is activated, everyone in your organization is forced to change their password periodically."
    },
    "singleSignOn": {
      "title": "Single Sign On Page"
    },
    "logo": {
      "title": "Upload Logo",
      "description": "Upload your organization's logo here and it will be displayed in exported documents."
    }
  },
  "users": {
    "searchPlaceholder": "Search users...",
    "filterByGroup": "Filter by group",
    "inviteUser": "Invite user",
    "setRole": "Set role",
    "addToGroup": "Add to group",
    "addToGroupCount": "Add {{count}} {{pluralized}} to group",
    "removeFromGroup": "Remove from group",
    "removeFromGroupCount": "Remove {{count}} {{pluralized}} from group",
    "manageGroups": "Manage groups",
    "manageGroupsCount": "Manage groups for {{count}} {{pluralized}}",
    "editUser": "Edit user",
    "removeUser": "Remove user",
    "cancelInvitation": "Cancel invitation",
    "resendInvitation": "Resend invitation",
    "usageMessage": "You are using {{activeUsersCount}} of {{activeUsersLimit}} active users and {{totalUsersCount}} of {{totalUsersLimit}} total users available on your current plan. Need more?",
    "upgradeSubscription": "Upgrade your subscription",
    "addMoreSeats": "Add more seats",
    "table": {
      "fullName": "Full name",
      "email": "Email",
      "role": "Role",
      "jobTitle": "Job title",
      "department": "Department",
      "location": "Location",
      "groups": "Groups",
      "access": "Access"
    },
    "inviteStatus": {
      "pending": "pending",
      "declined": "declined",
      "accepted": "accepted"
    },
    "editUsersUsage": "Edit users (Normal + Quality): {{activeUsersCount}} of {{activeUsersLimit}}",
    "basicUsersUsage": "Basic users: {{basicUsersCount}} of {{basicUsersLimit}}",
    "basicUsersUsageUnlimited": "Basic users: {{basicUsersCount}} (Unlimited)"
  },
  "reassignEntities": {
    "cancel": "Cancel",
    "makeReassignments": "Make reassignments",
    "previous": "Previous",
    "next": "Next",
    "removeUser": "Remove user",
    "confirm": "Confirm",
    "save": "Save",
    "allSelected": "All {{count}} selected:",
    "reviewInfo": "Review information below",
    "addUserToGroup": "Add user to group",
    "warningMessage": "If you proceed with removal, the following users will be added to the following groups required to access documents with private tags:",
    "userAddedToGroups": "{{userName}} will be added to the groups:",
    "steps": {
      "owner": "Documents",
      "changeRequestOwner": "Change Requests",
      "approver": "Approval actions",
      "reviewer": "Review actions",
      "issues": "Issues",
      "events": "Events",
      "tasks": "Tasks",
      "summary": "Confirm changes and remove user",
      "summaryRefactor": "Confirm user removal",
      "default_owner": "Default event assignee",
      "eventTemplateOwner": "Event Templates",
      "control": "Controls",
      "documentTemplateOwner": "Document templates"
    },
    "columns": {
      "id": "ID",
      "title": "Title",
      "newOwner": "New Owner",
      "status": "Status",
      "tags": "Tags",
      "name": "Name",
      "prefix": "Prefix"
    },
    "summary": {
      "documents": "Documents:",
      "documentTemplates": "Document templates:",
      "changeRequests": "Change Requests:",
      "controls": "Controls:",
      "eventTemplates": "Event Templates:",
      "approvalActions": "Approval actions:",
      "reviewActions": "Review actions:",
      "issueActions": "Issue actions:",
      "eventActions": "Event actions:",
      "issueCollaboratorNote": "If a new owner is already a collaborator on an event, they will be removed from its collaborators.",
      "taskActions": "Task actions:",
      "ownershipTransfer": "Ownership of {{count}} {{type}} will be transferred to {{name}}",
      "ownershipTransferPlural": "Ownership of {{count}} {{type}}s will be transferred to {{name}}",
      "actionTransfer": "{{count}} {{type}} action will be transferred to {{name}}",
      "actionTransferPlural": "{{count}} {{type}} actions will be transferred to {{name}}",
      "eventTemplateTransfer": "{{ownershipType}} of {{count}} event template will be transferred to {{name}}",
      "eventTemplateTransferPlural": "{{ownershipType}} of {{count}} event templates will be transferred to {{name}}"
    }
  },
  "groups": {
    "subtitle": "Create and manage user groups to organize your team and control access",
    "createNewGroup": "Create new group",
    "assignManagers": "Assign managers",
    "editGroup": "Edit group",
    "deleteGroup": "Delete group",
    "confirmDeleteTitle": "Confirm delete group",
    "confirmDeleteMessage": "Are you sure you want to delete \"{{groupName}}\" group? Deleting a group that is part of a Qualio Training Plan can impact your training assignments. Please check the Training Matrix to identify impacted plans.",
    "yesDeleteGroup": "Yes, delete group",
    "searchPlaceholder": "Search groups or managers...",
    "table": {
      "groupName": "Group name",
      "groupManagers": "Group managers",
      "includeInReports": "Include in training reports"
    },
    "noManagers": "--"
  },
  "groupForm": {
    "groupName": "Group name",
    "includeInReports": "Include in reports",
    "minLengthError": "Minimum length of 1 character required.",
    "duplicateError": "Group with name \"{{groupName}}\" already exists."
  },
  "roles": {
    "basic": "Basic",
    "normal": "Normal",
    "quality": "Quality"
  },
  "features": {
    "qualityEvents": {
      "name": "Quality events",
      "description": "A \"Quality Event\" is an event that requires a pre-defined action or response and tracking in accordance with regulatory requirements. Quality users can create an event, assign ownership, and sign-off on associated steps/actions.",
      "enable": "Enable quality events",
      "permissions": {
        "manageWorkflow": "Manage workflow",
        "manageAttributes": "Manage attributes",
        "workOnIssue": "Work on issue",
        "createIssue": "Create issue",
        "view": "View events",
        "create": "Create an event",
        "workOnExisting": "Work on an existing event",
        "manageTemplates": "Create and manage event templates"
      }
    },
    "migrations": {
      "name": "Migrations",
      "description": "Migrations manager allows you to easily upload documents into Qualio as you onboard.",
      "enable": "Enable migrations",
      "permissions": {
        "create": "Create",
        "view": "View",
        "prepare": "Prepare",
        "approve": "Approve",
        "uploadFiles": "Upload Files"
      }
    },
    "suppliers": {
      "name": "Suppliers",
      "description": "The Suppliers feature enables your team to configure your supplier policy, manage your Approved Supplier List, and store supplier audit documents.",
      "access": "Access Suppliers"
    },
    "designControls": {
      "name": "Design Controls",
      "description": "The Design Controls feature enables efficient management and documentation of your product's design and development process, ensuring compliance and quality.",
      "access": "Access Design Controls"
    },
    "compliance": {
      "name": "Compliance",
      "description": "The Compliance feature enables your team to manage frameworks, track requirement status, and demonstrate adherence to quality and regulatory standards.",
      "access": "Access Compliance"
    },
    "apiCapabilities": {
      "name": "API Capabilities",
      "description": "API Capabilities enables access to programmable interfaces for seamless integration and automation of your enterprise systems with Qualio documents and training.",
      "access": "Access API Capabilities",
      "deprecatedNote": "This enables access to the legacy API only. Please use \"Developer API tokens\" to grant access to the new API."
    },
    "events": {
      "name": "Events",
      "description": "The Events feature enables your team to create and manage all quality events from root cause to verification of effectiveness."
    },
    "notAvailable": "This feature is not available with your current license. Please contact your Customer Success representative to upgrade and enable quality events.",
    "disableConfirmation": "Existing data will be saved and made available when features are turned back on. However, any user permissions that have been modified will be deleted and reset to their default access when the feature is turned back on. Are you sure you want to disable?",
    "disableTitle": "Disable {{name}}",
    "yesDisable": "Yes, disable {{name}}",
    "enable": "Enable feature",
    "disable": "Disable {{name}}",
    "role": "Role",
    "access": "Access",
    "none": "None",
    "upgradeMessage": "This feature is not available with your current license. Please contact your Customer Success representative to upgrade and enable quality events."
  },
  "status": {
    "draft": "Draft",
    "forReview": "For review",
    "forApproval": "For approval",
    "approved": "Approved",
    "approvalDeclined": "Approval declined",
    "effective": "Effective"
  },
  "forms": {
    "fullName": "Full name",
    "email": "Email address",
    "role": "User role",
    "adminAccess": "Admin access",
    "billingAccess": "Billing access",
    "learnMoreRoles": "Learn more about user roles.",
    "labels": {
      "fullName": "Full name",
      "emailAddress": "Email address",
      "userRole": "User role",
      "jobTitle": "Job title",
      "department": "Department",
      "location": "Location",
      "adminAccess": "Admin access",
      "billingAccess": "Billing access",
      "name": "Name",
      "role": "Role",
      "groups": "Groups"
    },
    "placeholders": {
      "whatIsThisTokenFor": "What's this token for?",
      "filterByNameEmailGroup": "Filter by name, email or group name..."
    },
    "helperText": {
      "adminAccess": "Granting admin access will allow users to add/remove users and groups, and edit permissions",
      "adminAccessExtended": "Granting admin access will allow users to add/remove users, add/remove groups, and manage permissions to events and suppliers",
      "inviteUser": "An invitation message will be sent to the provided email address. It will contain a confirmation link which allows the email address owner to join your organization.",
      "learnMoreRoles": "Learn more about user roles.",
      "learnMorePermissions": "Learn more about permissions."
    },
    "permissions": {
      "viewEvents": "View events",
      "createEvents": "Create an event",
      "editEvents": "Work on an existing event",
      "manageEvents": "Create and manage event templates",
      "accessSuppliers": "Access Suppliers",
      "accessDesignControls": "Access Design Controls",
      "accessCompliance": "Access Compliance"
    }
  },
  "apiCapabilities": {
    "header": "API Capabilities",
    "description": "API Capabilities enables access to programmable interfaces for seamless integration and automation of your enterprise systems with Qualio documents and training.",
    "deprecatedDescription": "This enables access to the legacy API only. Please use \"Developer API tokens\" to grant access to the new API.",
    "errorFetchKeys": "Could not determine if company has API keys due to a server error.",
    "access": "Access API Capabilities"
  },
  "modals": {
    "updatePermissions": {
      "title": "Update individual permissions?",
      "message": "You are changing this user's role. They also have special individual permissions assigned in addition to their role. Would you like to update their individual permissions as well?",
      "yesUpdate": "Yes, update permissions",
      "noKeep": "No, keep current permissions"
    },
    "inviteUser": {
      "title": "Invite user",
      "sendInvitation": "Send invitation",
      "resendInvitation": "Resend invitation",
      "reinviteMessage": "{{email}} was previously an active member of this account. Reinviting them will restore their profile with previously completed activities."
    },
    "setRole": {
      "title": "Set role for selected users"
    },
    "addToGroup": {
      "title": "Add selected users to group",
      "adding": "Adding..."
    },
    "manageGroups": {
      "title": "Manage groups for selected users",
      "save": "Save",
      "saving": "Saving...",
      "searchPlaceholder": "Filter by group name..."
    },
    "removeFromGroup": {
      "title": "Remove selected users from group",
      "removing": "Removing...",
      "visibilityWarning": "Removing the selected users from this group will hide some documents or templates from their owners. Are you sure you want to continue?",
      "confirmTitle": "This action affects content visibility"
    },
    "removeUser": {
      "title": "Remove user",
      "confirmMessage": "Are you sure you want to remove user \"{{name}}\"?",
      "yesRemoveUser": "Yes, remove user"
    },
    "cancelInvite": {
      "title": "Cancel invitation",
      "confirmMessage": "Are you sure you want to cancel this user's invitation?",
      "yesCancelUser": "Yes, cancel user"
    },
    "assignManagers": {
      "title": "Assign Managers",
      "searchPlaceholder": "Filter by name, email or group name...",
      "assigning": "Assigning...",
      "save": "Save"
    },
    "editUser": {
      "title": "Edit user"
    },
    "editGroup": {
      "title": "Edit group"
    }
  },
  "editUser": {
    "title": "Edit user",
    "header": "Edit user",
    "general": "General",
    "permissions": "Permissions",
    "defaultPermissions": "Default permissions",
    "events": "Events",
    "suppliers": "Suppliers",
    "designControls": "Design Controls",
    "compliance": "Compliance",
    "eventsDescription": "The Events feature enables your team to create and manage all quality events from root cause to verification of effectiveness",
    "suppliersDescription": "The Suppliers feature enables your team to configure your supplier policy, manage your Approved Supplier List, and store supplier audit documents",
    "designControlsDescription": "The Design Controls feature enables efficient management and documentation of your product's design and development process, ensuring compliance and quality.",
    "complianceDescription": "The Compliance feature enables your team to manage frameworks, track requirement status, and demonstrate adherence to quality and regulatory standards.",
    "eventsWarning": "View events must be selected in order to enable additional permissions",
    "viewEventsWarning": "View events must be selected in order to enable additional permissions",
    "resetPermissions": "Reset to default permissions",
    "resetToDefault": "Reset to default permissions",
    "saveChanges": "Save changes",
    "eventsPermissions": "Events permissions",
    "defaultPermissionsTable": {
      "role": "Role",
      "defaultPermissions": "Default permissions"
    },
    "validation": {
      "invalidFullName": "Invalid Full Name",
      "invalidEmail": "Invalid Email"
    }
  },
  "messages": {
    "success": {
      "saved": "Saved successfully",
      "deleted": "Deleted successfully",
      "submitted": "Submitted for review",
      "invitationSent": "Invitation sent!",
      "invitationResent": "Invitation has been sent again!",
      "invitationCanceled": "Successfully canceled user invitation.",
      "userRemoved": "Successfully removed user.",
      "userDeleted": "Successfully deleted user!",
      "userUpdated": "Successfully updated user!",
      "groupCreated": "Successfully created group!",
      "groupDeleted": "Successfully deleted group!",
      "groupUpdated": "Successfully updated group!",
      "roleChanged": "Successfully changed role for {{count}} user(s)!",
      "usersAdded": "Successfully added {{count}} user(s) to chosen group",
      "usersRemoved": "Successfully removed {{count}} user(s) from chosen group",
      "groupsUpdated": "Successfully updated group membership!",
      "managersAssigned": "Managers assigned successfully",
      "permissionsUpdated": "Instance permissions successfully updated",
      "tokenCreated": "New token created",
      "tokenDeleted": "Developer API token successfully deleted",
      "tokenUpdated": "Developer API token successfully updated"
    },
    "error": {
      "generic": "An error occurred. Please try again.",
      "notFound": "Item not found",
      "unauthorized": "You are not authorized to perform this action",
      "sendInvitation": "Something went wrong! Unable to send invitation.",
      "resendInvitation": "Something went wrong! Unable to resend invitation.",
      "cancelInvitation": "Something went wrong! Unable to cancel user invitation.",
      "removeUser": "Something went wrong! Unable to remove user.",
      "updateUser": "Something went wrong! Unable to update user.",
      "extractOwnedItems": "Something went wrong! Unable to extract owned items for this user.",
      "createGroup": "Something went wrong! Unable to create group.",
      "deleteGroup": "Something went wrong! Unable to delete group.",
      "updateGroup": "Something went wrong! Unable to update group.",
      "updateRole": "Something went wrong! Unable to update role.",
      "setUsersToGroup": "Unable to set users to selected group",
      "addUsersToGroup": "Unable to set users to selected group",
      "removeUsersFromGroup": "Unable to remove user(s) from selected group",
      "manageGroups": "Unable to update group membership. Please try again.",
      "assignManagers": "Failed to assign managers",
      "updateMfa": "Could not update MFA status for this company",
      "updatePermissions": "Failed to update instance permissions",
      "loadSettings": "Failed to load settings.",
      "fetchFeatures": "Failed to fetch features",
      "updateFeatures": "Failed to update features",
      "createToken": "Could not create the requested API KEY due to a server error",
      "tokenNameExists": "An API key with this name already exists. Please choose a different name.",
      "deleteToken": "Could not delete the requested API KEY due to a server error",
      "rotateToken": "Could not rotate the requested API KEY due to a server error",
      "showApiKeys": "Could not show API keys due to a server error",
      "reassignEntities": "Failed to reassign entities. Please try again.",
      "updateToken": "Could not update the requested API token due to a server error"
    },
    "validation": {
      "required": "This field is required",
      "invalidEmail": "Invalid email address.",
      "minLength": "Must be at least {{min}} characters",
      "maxLength": "Must be no more than {{max}} characters",
      "invalidTokenName": "Invalid token name",
      "minimumAdmins": "This operation would result in zero admins for the company. The minimum required admins for each company is 1.",
      "minimumQuality": "Company requires at least one Quality user.",
      "documentsHidden": "This action would cause one or more documents to be hidden from their owners.",
      "templatesHidden": "This action would cause one or more templates to be hidden from their owners.",
      "userAlreadyExists": "User registered with email {{email}} is already a member of this company.",
      "totalUsersLimit": "Limit of total users reached.",
      "activeUsersLimit": "Limit of active users reached.",
      "userExistsInQualio": "A user already exists in Qualio with this email address."
    }
  },
  "emptyStates": {
    "noResults": "No results found",
    "noData": "There is no data to display.",
    "noBetaFeatures": {
      "title": "No active beta features available",
      "subtitle": "Please check back again in the future. We are always working on improvements to the Qualio experience."
    },
    "noApiTokens": {
      "title": "No API tokens created",
      "subtitle": "Need an API token for scripts or testing? Generate an API token for quick access to the Qualio API.",
      "viewPortal": "View Developer Portal",
      "createToken": "Create token"
    },
    "noApiAccess": {
      "title": "You do not have access to the Developer API",
      "subtitle": "Contact our support team so you can access the Developer API in Qualio.",
      "contactSupport": "Contact Qualio support"
    }
  },
  "security": {
    "description": "Manage authentication requirements and security settings for all users in your organization.",
    "mfa": {
      "label": "Multi-factor authentication",
      "description": "Require all users in your organization to provide a verification code in addition to their password when signing in, enhancing overall security.",
      "enable": "Enable Multi-factor authentication",
      "disableTitle": "Disable multi-factor authentication",
      "disableMessage": "Are you sure you want to disable this setting? Users will not be required to sign-in using multi-factor authentication once disabled."
    }
  },
  "permissions": {
    "instancePermissions": "Instance permissions",
    "aiEditing": {
      "label": "AI-powered editing",
      "description": "Suggested training assessments, change controls and document improvements powered by AI.",
      "enable": "Enable AI-powered editing"
    },
    "mcp": {
      "label": "MCP access",
      "description": "Allow AI assistants and agents to connect to this instance through Qualio's MCP server.",
      "enable": "Enable MCP access"
    },
    "copilot": {
      "label": "Qualio Copilot",
      "description": "Enable the Qualio Copilot AI assistant for this instance.",
      "enable": "Enable Copilot"
    },
    "reviewers": {
      "label": "Reviewers",
      "description": "Grant Basic users permission to be added as a reviewer on documents.",
      "enable": "All basic users can be reviewers"
    },
    "supportAccess": {
      "label": "Qualio support access",
      "description": "Allow Qualio support to access your instance in read-only mode.",
      "enable": "Enable support access"
    },
    "saveChanges": "Save changes",
    "termsOfService": {
      "prefix": "Permissions marked with",
      "tos": "enable AI-powered features. By enabling them, you agree to be bound by Qualio's Terms of Service.",
      "fairUsage": "To ensure a consistent experience for all users, we may introduce usage limits during periods of high demand."
    }
  },
  "betaFeatures": {
    "description": "Explore and test the latest features we're crafting by enabling them in your instance. Your feedback helps us refine and perfect these innovations, so let us know what you think. When enabling a beta feature, it may take a few minutes for the change to take effect. If you don't see the changes, try refreshing your browser. Learn more about these features on our",
    "helpCenter": "Help Center.",
    "packageNotice": "Access to beta features after general availability may be package-dependent. Reach out to your CSM to learn more.",
    "enabled": "Enabled {{name}}",
    "disabled": "Disabled {{name}}",
    "enable": "Enable {{name}}",
    "termsOfService": {
      "prefix": "By clicking a toggle to enable any of the following beta features, you agree to be bound by Qualio's",
      "terms": "Terms of Service,",
      "middle": "whereby the beta features you enable will be part of the \"Beta features\" for purposes of the",
      "suffix": "Terms of Service."
    }
  },
  "devApi": {
    "backToTokens": "Back to API tokens",
    "createToken": "Create Token",
    "tokenRoleHelper": "What role would you like this token to have the privileges of?",
    "adminAccessHelper": "Grant this token the ability to add/remove users, add/remove groups, and manage permissions to events and suppliers.",
    "tokenGroupsHelper": "Optionally add this token to groups to allow it to see private documents, events, etc, just like a user.",
    "editToken": "Edit Token"
  },
  "developerApi": {
    "description": "API tokens are a secure, unique keys that allows authenticated access to the Qualio API. They enable seamless integration with external systems to automate workflows, sync data, and enhance compliance tracking.",
    "manageDescription": "Here, you can manage your API tokens. You can create, delete and rotate them. Rotating a token will generate a new token key and invalidate the old one. The name and permissions will not be changed.",
    "expirationNote": "Each token will expire after one year, if they are not rotated. Any actions performed using the key will be logged to the audit trail with the name you choose for the token.",
    "docsAlert": "Integrating with the Qualio API? Find guides and the full API reference in our developer portal.",
    "viewApiDocs": "View API docs",
    "createToken": "Create token",
    "backToTokens": "Back to API tokens",
    "createTokenHeader": "Create Token",
    "tokenName": "Name",
    "tokenRole": "Role",
    "tokenRoleHelper": "What role would you like this token to have the privileges of?",
    "tokenGroups": "Groups",
    "tokenGroupsHelper": "Optionally add this token to groups to allow it to see private documents, events, etc, just like a user.",
    "adminAccessHelper": "Grant this token the ability to add/remove users, add/remove groups, and manage permissions to events and suppliers.",
    "tokenCreatedTitle": "New token created",
    "storeSecurelyTitle": "Store this token securely",
    "storeSecurelyMessage": "This is the only time when you will be able to view the full token.",
    "apiTokenLabel": "API Token",
    "copyToken": "Copy token",
    "tokenLostWarning": "If the token is lost, you will need to generate a new one. Regenerating a new token will invalidate the old token, but it will have the same permissions and name.",
    "deleteToken": "Delete Developer API token",
    "confirmDeleteTitle": "Confirm delete token",
    "confirmDeleteMessage": "Are you sure you want to delete the \"{{tokenName}}\" token? Any integration using this token will immediately lose access to the Qualio API.",
    "confirmRotateTitle": "Confirm rotate token",
    "confirmRotateMessage": "Are you sure you want to rotate the \"{{tokenName}}\" token? This generates a new token key and immediately invalidates the current one, so any integration using it will lose access until updated.",
    "table": {
      "name": "Name",
      "created": "Created",
      "expires": "Expires",
      "type": "Type",
      "personal": "Personal",
      "system": "System",
      "personalTooltip": "This token is linked to a real user and inherits their access. It will stop working if that user is deactivated.",
      "systemTooltip": "This token is not linked to a real user and has its own permissions.",
      "rotate": "Rotate",
      "delete": "Delete"
    }
  },
  "reassign": {
    "removeUserTitle": "Remove User: {{name}}",
    "removeUserTitleGeneric": "Remove User",
    "description": "Before removing a user you must transfer ownership of documents and outstanding issues, tasks, and actions to other users.",
    "descriptionEvents": "Before removing a user you must transfer ownership of documents and outstanding events, tasks, and actions to other users.",
    "descriptionExtended": "Before removing a user you must transfer ownership of documents, templates, outstanding issues, tasks, and actions to other users.",
    "descriptionExtendedEvents": "Before removing a user you must transfer ownership of documents, templates, outstanding events, tasks, and actions to other users.",
    "steps": {
      "documents": "Documents",
      "changeRequests": "Change Requests",
      "approvalActions": "Approval actions",
      "reviewActions": "Review actions",
      "issues": "Issues",
      "tasks": "Tasks",
      "confirmChanges": "Confirm changes and remove user",
      "defaultEventAssignee": "Default event assignee",
      "eventTemplates": "Event Templates",
      "controls": "Controls",
      "documentTemplates": "Document templates"
    },
    "bulkSelect": {
      "allSelected": "All {{size}} selected:",
      "save": "Save"
    },
    "table": {
      "id": "ID",
      "title": "Title",
      "newOwner": "New Owner",
      "status": "Status",
      "tags": "Tags",
      "name": "Name",
      "prefix": "Prefix"
    },
    "summary": {
      "reviewInfo": "Review information below",
      "addUserToGroupTitle": "Add user to group",
      "addUserToGroupMessage": "If you proceed with removal, the following users will be added to the following groups required to access documents with private tags:",
      "userAddedToGroups": "{{userName}} will be added to the groups: {{groupNames}}"
    }
  },
  "aria": {
    "userlistCheckbox": "userlist_checkbox",
    "addToGroup": "Add to group",
    "removeFromGroup": "Remove from group",
    "manageGroups": "Manage groups",
    "adminAccess": "admin access",
    "billingAccess": "billing access",
    "email": "email",
    "fullName": "fullName",
    "role": "role",
    "group": "group",
    "groupName": "group name",
    "includeInReports": "include in reports",
    "inviteUserForm": "inviteUserForm",
    "groupForm": "group form",
    "nextButton": "next_button",
    "canViewQualityEvents": "can view quality events",
    "canCreateQualityEvents": "can create quality events",
    "canEditQualityEvents": "can edit quality events",
    "canManageQualityEvents": "can manage quality events"
  }
}
